module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-wrapper"
  }, [_c('ul', {
    ref: "carouselWrapper",
    staticClass: "slider-list"
  }, _vm._l((_vm.items), function(slide, index) {
    return _c('div', {
      ref: "sliderSlide",
      refInFor: true,
      staticClass: "slider-item",
      staticStyle: {
        "width": "720px"
      }
    }, [_vm._t("slideItem", null, {
      "slide": slide,
      "index": index
    })], 2)
  }), 0), _c('div', {
    staticClass: "slider-bullets flex-wrap px-lg-5 mt-5 px-3 justify-content-center justify-content-md-start"
  }, [_vm._l((_vm.items), function(slide, index) {
    return _c('div', {
      staticClass: "slider-bullet align-items-center mt-md-0 mt-4",
      class: {
        active: _vm.currentSlide === index || 0
      },
      on: {
        "click": function($event) {
          return _vm.carousel.navigate.toSlide(index)
        }
      }
    })
  }), _vm._t("underBulletContent")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-135010ec","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/signboardNew/ContentSlider.vue
// module id = ddffde125ecc8b1119dd
// module chunks = 0